import { Box, Button, Checkbox, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, FormControlLabel, MenuItem, Stack, Step, StepConnector, stepConnectorClasses, StepLabel, Stepper, Table, TableBody, TableCell, TableHead, TableRow, TextField, Typography, useMediaQuery, useTheme } from '@mui/material'
import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types';
import Header from '../../../components/Header'
import { useLocation, useNavigate } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { getBom, getBomById } from '../../../redux/slice/bom.slice';
import { useDispatch, useSelector } from 'react-redux';
import { addSales, editSales, getBomByIdSales, getBomSales1, getcategorySales, getproductSales, getSales, getSalesById, getsubcategorySales, gettermsSales, updateSalesDetailsById } from '../../../redux/slice/sales.slice';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';


const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
    [`&.${stepConnectorClasses.alternativeLabel}`]: {
        top: 22,
    },
    [`&.${stepConnectorClasses.active}`]: {
        [`& .${stepConnectorClasses.line}`]: {
            backgroundImage: 'linear-gradient( 95deg,#222222 0%, #FFFFFF 120%)',
        },
    },
    [`&.${stepConnectorClasses.completed}`]: {
        [`& .${stepConnectorClasses.line}`]: {
            backgroundImage: 'linear-gradient( 95deg,#222222 0%, #FFFFFF 120%)',
        },
    },
    [`& .${stepConnectorClasses.line}`]: {
        height: 3,
        border: 0,
        backgroundColor: theme.palette.mode === 'dark' ? theme.palette.grey[800] : '#eaeaf0',
        borderRadius: 1,
    },
}));

const ColorlibStepIconRoot = styled('div')(({ theme, ownerState }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? theme.palette.grey[700] : '#ccc',
    zIndex: 1,
    color: '#fff',
    width: 50,
    height: 50,
    display: 'flex',
    borderRadius: '50%',
    justifyContent: 'center',
    alignItems: 'center',
    ...(ownerState.active && {
        border: theme.palette.mode === 'dark' ? '2px solid white' : '2px solid black',
        boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
    }),
    ...(ownerState.completed && {
        border: theme.palette.mode === 'dark' ? '2px solid white' : '2px solid black',
    }),
    ...(ownerState.error && {
        border: '2px solid red',
    }),
}));

function ColorlibStepIcon(props) {
    const { active, completed, className, icon, onClick, theme, error } = props;
    const icons = {
        1: <img src="/assets/images/icons/file.svg" style={{ filter: theme.palette.mode === 'light' ? 'invert(1) brightness(2)' : 'invert(0) brightness(1)' }} width="25" height="26" alt='' />,
        2: <img src="/assets/images/icons/bom.svg" style={{ filter: theme.palette.mode === 'light' ? 'invert(1) brightness(2)' : 'invert(0) brightness(1)' }} width="25" height="26" alt='' />,
        3: <img src="/assets/images/icons/offer.svg" style={{ filter: theme.palette.mode === 'light' ? 'invert(1) brightness(2)' : 'invert(0) brightness(1)' }} width="25" height="26" alt='' />,
        4: <img src="/assets/images/icons/important.svg" style={{ filter: theme.palette.mode === 'light' ? 'invert(1) brightness(2)' : 'invert(0) brightness(1)' }} width="25" height="26" alt='' />,
    };

    return (
        <ColorlibStepIconRoot ownerState={{ completed, active, error }} className={className} onClick={onClick}>
            {icons[String(icon)]}
        </ColorlibStepIconRoot>
    );
}

ColorlibStepIcon.propTypes = {
    active: PropTypes.bool,
    className: PropTypes.string,
    icon: PropTypes.node,
    onClick: PropTypes.func,
    filledSteps: PropTypes.array,
};

const steps = ['Customer Basic Details', 'Bill of Material', 'Commercial Offer', 'Important Remarks'];

const AddSales = () => {

    const { state } = useLocation();
    const salesData = state;
    const BomId = state?.id || salesData?.bomId;
    const Sales = useSelector(state => state?.sales.Sales);

    const Sales1 = useSelector(state => state?.sales);
    console.log(Sales1);

    const id = salesData?._id;
    const bomData = useSelector(state => state.bom.Bom);

    const validationSchemas =
        Yup.object({});

    const initialValues = {
        Date: '',
        bomId: BomId,
        customerName: '',
        location: '',
        systemSize: '',
        TypesOfProject: '',
        SalesDetails: [
            {
                salescategory: '',
                salessubcategory: '',
                salesproduct: '',
                salesmake: '',
                salesspecifiaction: '',
            }
        ],
        Amount1: '',
        Amount2: '',
        Amount3: '',
        Amount4: '',
        Amount5: '',
        Amount6: '',
    };


    const getUserId = localStorage.getItem('id');
    const theme = useTheme();
    const isNonMobile = useMediaQuery("(min-width:600px)");
    const isSmallScreen = useMediaQuery("(max-width:425px)");
    const isMobile = useMediaQuery('(max-width:500px)');

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [salesdata, setsalesdata] = useState(initialValues.SalesDetails)
    const [filteredProducts, setFilteredProducts] = useState([]);
    const terms = useSelector(state => state.sales.Terms);
    const categories = useSelector(state => state.sales.category);
    const subcategories = useSelector(state => state.sales.subCategory);
    const productData = useSelector(state => state.sales.products)
    const [acceptedTerms, setAcceptedTerms] = useState({});

    const [salesDetails, setSalesDetails] = useState([]);

    console.log(salesDetails);


    useEffect(() => {
        dispatch(getSales())
        dispatch(getcategorySales());
        dispatch(getsubcategorySales());
        dispatch(getproductSales());
        dispatch(gettermsSales());
        if (BomId) {
            dispatch(getBomByIdSales(BomId));
        } else {
            dispatch(getBomSales1());
        }
    }, []);

    const handleTermChange = (termId) => {
        setAcceptedTerms(prev => ({
            ...prev,
            [termId]: !prev[termId]
        }));
    };



    useEffect(() => {
        if (salesData?._id && salesData?.acceptedTerms) {
            const initialAcceptedTerms = salesData.acceptedTerms.reduce((acc, termId) => {
                acc[termId] = true;
                return acc;
            }, {});
            setAcceptedTerms(initialAcceptedTerms);
        }
    }, [salesData]);

    useEffect(() => {
        if (id) {
            setValues({
                ...salesData,
                TypesOfProject: salesData.TypesOfProject || '',
                SalesDetails: salesData.SalesDetails || []
            });
            setsalesdata(salesData?.SalesDetails || []);
            setIsNewSales(false);
            const newFilteredProducts = salesData?.SalesDetails?.map(detail => {
                return productData?.filter(product =>
                    product.subCategoryData?.some(sub => sub._id === detail.salessubcategory)
                ) || [];
            });
            setFilteredProducts(newFilteredProducts);
            if (salesData.terms && Array.isArray(salesData.terms)) {
                const initialAcceptedTerms = salesData.terms.reduce((acc, termId) => {
                    acc[termId] = true;
                    return acc;
                }, {});
                setAcceptedTerms(initialAcceptedTerms);
            }
        } else {
            if (id) {
                dispatch(getSalesById(id))
            } else {
                dispatch(getSales())
                resetForm();
                setIsNewSales(true);
            }
        }
    }, [id, salesData])


    useEffect(() => {
        if (id) {
            setValues(salesData);
            const newFilteredProducts = salesData.SalesDetails?.map(detail => {
                return productData?.filter(product =>
                    product.subCategoryData?.some(sub => sub._id === detail.salessubcategory)
                ) || [];
            });
            setFilteredProducts(newFilteredProducts);
        }
    }, [id, salesData, productData])

    useEffect(() => {
        if (BomId) {
            setValues(bomData);
            setFieldValue('customerName', bomData.BOMName);
            setFieldValue('Amount1', bomData.Amount1);
        }
    }, [BomId, bomData])





    const [activeStep, setActiveStep] = React.useState(0);
    const [stepsWithErrors, setStepsWithErrors] = React.useState([false, false, false, false]);
    const [touchedSteps, setTouchedSteps] = React.useState([false, false, false, false]);
    const [QuotationNo, setQuotationNo] = React.useState('');
    const [isNewSales, setIsNewSales] = React.useState(true);

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };
    const handleStep = (step) => {
        setActiveStep(step);
    };

    const handleNext = () => {
        setActiveStep((prev) => prev + 1);

    }

    React.useEffect(() => {
        if (isNewSales) {
            const currentDate = new Date();
            let financialYear;

            if (currentDate.getMonth() >= 3) {
                financialYear = `${currentDate.getFullYear()}-${(currentDate.getFullYear() + 1).toString().slice(-2)}`;
            } else {
                financialYear = `${currentDate.getFullYear() - 1}-${currentDate.getFullYear().toString().slice(-2)}`;
            }

            const maxQuotationNo = Sales && Sales.length > 0
                ? Math.max(...Sales.map(sale => {
                    const parts = sale.QuotationNo.split('/');
                    return parseInt(parts[3]);
                }))
                : 0;

            const sequenceNumber = Sales1.allSalesCount + 1;

            setQuotationNo(`TEL/QUO/${financialYear}/${sequenceNumber.toString().padStart(4, '0')}`);
        } else {
            setQuotationNo(salesData?.QuotationNo);
        }
    }, [Sales, isNewSales]);

    const handleSubmit = (values) => {
        console.log("values 1", values)
        validationSchemas.validate(values, { abortEarly: false })
            .then(() => {
                const submissionValues = {
                    ...values,
                    bomId: BomId,
                    userId: getUserId,
                    QuotationNo: QuotationNo,
                    Amount2: values.Amount2,
                    SalesDetails: values?.SalesDetails?.map(detail => ({
                        salescategory: detail.salescategory || null,
                        salessubcategory: detail.salessubcategory || null,
                        salesproduct: detail.salesproduct || null,
                        salesmake: detail.salesmake || null,
                        salesspecifiaction: detail.salesspecifiaction || null,
                    })),
                    terms: Object.keys(acceptedTerms).filter(termId => acceptedTerms[termId]),
                };
                if (id) {
                    dispatch(editSales({ _id: id, ...submissionValues }));
                } else {
                    dispatch(addSales({ ...submissionValues, QuotationNo }));
                }
                setActiveStep(0);
                setIsNewSales(true);
                navigate('/admin/sales');
                setAcceptedTerms({});
            })
            .catch((validationErrors) => {
                console.log("Form validation errors:", validationErrors);
                alert("Please fill in all required fields before submitting.");
            });
    }

    const { handleBlur, handleChange, values, touched, errors, setFieldValue, setValues, resetForm } = useFormik({
        initialValues: initialValues,
        validationSchema: validationSchemas,
        onSubmit: handleSubmit,
    });

    const handleAmountChangeFS = (e, fieldName) => {
        const value = parseFloat(e.target.value) || 0;
        setFieldValue(fieldName, value); // Set the current field value

        let amount1 = fieldName === 'Amount1' ? value : parseFloat(values.Amount1) || 0;
        let amount2 = fieldName === 'Amount2' ? value : parseFloat(values.Amount2) || 0;
        let amount3 = fieldName === 'Amount3' ? value : parseFloat(values.Amount3) || 0;
        let amount5 = fieldName === 'Amount5' ? value : parseFloat(values.Amount5) || 0;

        const amount4 = amount1 + amount2 + amount3;
        const amount6 = amount4 - amount5;

        setFieldValue('Amount4', amount4.toFixed(2));
        setFieldValue('Amount6', amount6.toFixed(2));

        console.log(amount1, amount2, amount3, amount4, amount5, amount6);
    };



    const [open, setOpen] = useState(false);
    const [currentBom, setCurrentBom] = useState(null);

    const handleViewBom = (bomId) => {
        setCurrentBom(bomId);
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const formatDate = (date) => {
        const options = { year: 'numeric', month: 'numeric', day: 'numeric' };
        return new Date(date).toLocaleDateString(undefined, options);
    }

    useEffect(() => {
        if (values?.TypesOfProject) {

            console.log(salesData);

            let details = [];
            if (salesData?.SalesDetails && salesData.SalesDetails.length > 0 && salesData.TypesOfProject === values?.TypesOfProject) {
                details = salesData.SalesDetails;


            } else {
                setFieldValue("Amount1", '');
                setFieldValue("Amount2", '');
                setFieldValue("Amount3", '');
                setFieldValue("Amount4", '');
                setFieldValue("Amount5", '');
                setFieldValue("Amount6", '');
                switch (values.TypesOfProject) {
                    case 'Residential Individual':
                    case 'Residential Comman Meter':
                        console.log("rrrr");

                        details = [
                            {
                                salesproduct: 'Solar PV Module',
                                salesmake: 'Waaree / Adani',
                                salesspecifiaction: '540Wp Bifacial'
                            },
                            {
                                salesproduct: 'Solar Grid Tie Inverter',
                                salesmake: 'Solax / Polycab / Sofar',
                                salesspecifiaction: 'Outdoor String Inverter Capacity 3.3 KW x 1 Nos'
                            },
                            {
                                salesproduct: 'Module Mounting Structure',
                                salesmake: 'Hindustar',
                                salesspecifiaction: '60 x 40 Rafter and Leg ,40 x 40 Perlin'
                            },
                            {
                                salesproduct: 'DC Cables',
                                salesmake: 'Polycab or Equivalent',
                                salesspecifiaction: '4 Sq. MM x 1 Core Cu Flexible'
                            },
                            {
                                salesproduct: 'AC Cables',
                                salesmake: 'Polycab or Equivalent',
                                salesspecifiaction: '4 Sq. MM x 2 Core'
                            },
                            {
                                salesproduct: 'Earthing Green Cable',
                                salesmake: 'Polycab or Equivalent',
                                salesspecifiaction: '4 Sq. MM x 1 Core Cu Flexible'
                            },
                            {
                                salesproduct: 'Earthing Kit',
                                salesmake: 'Electrical Standard and As per Tender Norms',
                                salesspecifiaction: 'Standard Lightning Arrester and LA cable Any Reputed Make'
                            },
                            {
                                salesproduct: 'ACDB & DCDB',
                                salesmake: 'Havelles / Elmex or L & K / Finder',
                                salesspecifiaction: 'As Per Site Design'
                            }
                        ];
                        break;
                    case 'Commercial with Large BOM':
                        console.log("llll");

                        details = [
                            {
                                salesproduct: 'Solar PV Module',
                                salesmake: 'Credence / Waaree',
                                salesspecifiaction: '540Wp Bifacial'
                            },
                            {
                                salesproduct: 'Solar Grid Tie Inverter',
                                salesmake: 'Solax / Polycab / Sofar',
                                salesspecifiaction: 'Outdoor String Inverter Capacity 50 KW x 2 Nos'
                            },
                            {
                                salesproduct: 'Module Mounting Structure',
                                salesmake: 'Hindustar',
                                salesspecifiaction: '60 x 40 Rafter and Leg ,40 x 40 Perlin'
                            },
                            {
                                salesproduct: 'DC Cables',
                                salesmake: 'Polycab / RR or Equivalent',
                                salesspecifiaction: '4 Sq. MM x 1 Core Cu Flexible'
                            },
                            {
                                salesproduct: 'AC Cables',
                                salesmake: 'Polycab / RR or Equivalent',
                                salesspecifiaction: 'Alluminum Armoured (Cabel Size As per plant design and site requirement)'
                            },
                            {
                                salesproduct: 'Cable Tray',
                                salesmake: 'EPP/Aum/Aeron or Equivalent',
                                salesspecifiaction: 'Galvanized Coating Gi Perforated'
                            },
                            {
                                salesproduct: 'Walkway',
                                salesmake: 'EPP / Aron / Makwell or Equivalent',
                                salesspecifiaction: 'FRP Material Walk Way Size - 310 x 25 MM'
                            },
                            {
                                salesproduct: 'LT Panel / ACDB',
                                salesmake: 'Havelles, L&T, & Schneider System house',
                                salesspecifiaction: 'As per plant design and site requirement'
                            },
                            {
                                salesproduct: 'Earthing',
                                salesmake: 'Vasudha / Connect Earth / Eliva or Equivalent',
                                salesspecifiaction: '50 mm die / 3 Meter Depth HDGI Chemical Earthing'
                            },
                            {
                                salesproduct: 'Lightning Arrester',
                                salesmake: 'Vasudha / Connect Earth / Eliva or Equivalent',
                                salesspecifiaction: 'As per IS / Electrical Standard ( LA Cabel any reputed make )'
                            },
                            {
                                salesproduct: 'Hardware',
                                salesmake: 'Perfect / Sunshine or Equivalent',
                                salesspecifiaction: 'SS 304'
                            },
                            {
                                salesproduct: 'Panel Cleaning System',
                                salesmake: 'Finolex / Astral or Equivalent',
                                salesspecifiaction: 'NA'
                            },
                            {
                                salesproduct: 'Balance of System',
                                salesmake: 'Any Reputed Make',
                                salesspecifiaction: 'As per IS / Electrical Standard (As per plant design and site requirement)'
                            },
                            {
                                salesproduct: 'Generation Meter',
                                salesmake: 'Secure / HPL or Equivalent',
                                salesspecifiaction: 'As per DISCOM Specification'
                            },
                            {
                                salesproduct: 'Inverter Canopy',
                                salesmake: '-',
                                salesspecifiaction: 'As per plant design and site requirement'
                            },
                        ];
                        break;
                    case 'Commercial with Small BOM':
                        details = [
                            {
                                salesproduct: 'Solar PV Module',
                                salesmake: 'Waaree / Adani',
                                salesspecifiaction: '540Wp Bifacial'
                            },
                            {
                                salesproduct: 'Solar Grid Tie Inverter',
                                salesmake: 'Solax / Polycab / Sofar',
                                salesspecifiaction: 'Outdoor String Inverter Capacity 3.3 KW x 1 Nos'
                            },
                            {
                                salesproduct: 'Module Mounting Structure',
                                salesmake: 'Hindustar',
                                salesspecifiaction: '60 x 40 Rafter and Leg ,40 x 40 Perlin'
                            },
                            {
                                salesproduct: 'DC Cables',
                                salesmake: 'Polycab or Equivalent',
                                salesspecifiaction: '4 Sq. MM x 1 Core Cu Flexible'
                            },
                            {
                                salesproduct: 'AC Cables',
                                salesmake: 'Polycab or Equivalent',
                                salesspecifiaction: '4 Sq. MM x 2 Core'
                            },
                            {
                                salesproduct: 'Earthing Green Cable',
                                salesmake: 'Polycab or Equivalent',
                                salesspecifiaction: '4 Sq. MM x 1 Core Cu Flexible'
                            },
                            {
                                salesproduct: 'Earthing Kit',
                                salesmake: 'Electrical Standard',
                                salesspecifiaction: 'Standard Lightning Arrester and LA cable Any Reputed Make'
                            },
                            {
                                salesproduct: 'ACDB & DCDB',
                                salesmake: 'Havelles / Elmex or L & K / Finder',
                                salesspecifiaction: 'As Per Site Design'
                            },
                            {
                                salesproduct: 'Cable Tray',
                                salesmake: 'EPP/Aum/Aeronor Equivalent',
                                salesspecifiaction: 'NA'
                            },
                            {
                                salesproduct: 'Walkway ',
                                salesmake: 'EPP / Aron / Makwell or Equivalent',
                                salesspecifiaction: 'NA'
                            }
                        ];
                        break;
                    case 'Individual':
                        details = [
                            {
                                salesproduct: 'Solar PV Module',
                                salesmake: 'Waaree / Adani',
                                salesspecifiaction: '540Wp Bifacial'
                            },
                            {
                                salesproduct: 'Solar Grid Tie Inverter',
                                salesmake: 'Solax / Polycab / Sofar',
                                salesspecifiaction: 'Outdoor String Inverter Capacity 3.3 KW x 1 Nos'
                            },
                            {
                                salesproduct: 'Module Mounting Structure',
                                salesmake: 'Hindustar',
                                salesspecifiaction: '60 x 40 Rafter and Leg ,40 x 40 Perlin'
                            },
                            {
                                salesproduct: 'ACDB & DCDB',
                                salesmake: 'Havelles / Elmex or L & K / Finder',
                                salesspecifiaction: 'As Per Site Design'
                            },
                            {
                                salesproduct: 'GEDA registration, DISCOM and Net meter Charges',
                                salesmake: 'Included',
                                salesspecifiaction: 'Included'
                            }
                        ];
                        break;
                    default:
                        details = [];
                }
            }
            console.log(details, values.TypesOfProject);

            setSalesDetails(details);
            setFieldValue('SalesDetails', details);

            console.log(salesDetails);

        }


    }, [values?.TypesOfProject]);

    useEffect(() => {
        if (bomData.TypesOfProject === 'Commercial with Large BOM' || bomData.TypesOfProject === 'Commercial with Small BOM')
            if (bomData?.Amount1) {
                setFieldValue('Amount1', bomData.Amount1);
            }
    }, [bomData]);

    const handleAmountChange = (e, fieldName) => {
        const value = e.target.value;
        handleChange(e);

        console.log("values 2", values)

        if (fieldName === 'Amount1') {
            const baseAmount = parseFloat(value) || 0;
            const gstPercentage = new Date(values.Date) <= new Date("2025-09-21") ? 13.8 : 8.9;

            const gstAmount = (baseAmount * gstPercentage) / 100;

            const f = gstAmount + baseAmount;

            console.log(gstAmount, f, baseAmount);


            if (baseAmount > 0) {
                setFieldValue('Amount3', f);
                setFieldValue('Amount2', gstAmount.toFixed(2));

            } else {
                setFieldValue('Amount3', '');
            }
        }
    }

    console.log(terms?.filter(t => t.TermsType === "Sales"));

    useEffect(() => {
        if (values.Amount1 && values.TypesOfProject !== "Residential Individual" && values.TypesOfProject !== 'Residential Comman Meter') {
            const baseAmount = parseFloat(values.Amount1) || 0;

            // Choose GST % based on date
            const gstPercentage =
                new Date(values.Date) <= new Date("2025-09-21") ? 13.8 : 8.9;

            const gstAmount = (baseAmount * gstPercentage) / 100;
            const finalAmount = baseAmount + gstAmount;

            setFieldValue("Amount2", gstAmount.toFixed(2));
            setFieldValue("Amount3", finalAmount.toFixed(2));
        } else {
            setFieldValue("Amount2", "");
            setFieldValue("Amount3", "");
        }
    }, [values.Date, values.Amount1, setFieldValue]);

    return (
        <Box m="2px">
            {id ? (
                <Header
                    title="UPDATE SALES"
                    subtitle="Update Your Sales Detail"
                />
            ) : (
                <Header
                    title="ADD SALES"
                    subtitle="Manage Your Sales Detail"
                />
            )}
            <form onSubmit={handleSubmit} >
                <Stack sx={{ width: '100%', marginTop: '30px' }} spacing={4}>
                    {isSmallScreen ? (
                        <>
                            <Stepper alternativeLabel activeStep={activeStep} connector={<ColorlibConnector />}>
                                {steps.slice(0, 3).map((label, index) => (
                                    <Step key={label}>
                                        <StepLabel StepIconComponent={(props) => (
                                            <ColorlibStepIcon
                                                {...props}
                                                theme={theme}
                                                icon={index + 1}
                                                onClick={() => handleStep(index)}
                                                error={touchedSteps[index] && stepsWithErrors[index]}
                                            />
                                        )}>
                                            {label}
                                        </StepLabel>
                                    </Step>
                                ))}
                            </Stepper>
                            <Stepper alternativeLabel activeStep={activeStep} connector={<ColorlibConnector />}>
                                {steps.slice(3).map((label, index) => (
                                    <Step key={label}>
                                        <StepLabel StepIconComponent={(props) => (
                                            <ColorlibStepIcon
                                                {...props}
                                                theme={theme}
                                                icon={index + 4}
                                                onClick={() => handleStep(index + 3)}
                                                error={touchedSteps[index + 3] && stepsWithErrors[index + 3]}
                                            />
                                        )}>
                                            {label}
                                        </StepLabel>
                                    </Step>
                                ))}
                            </Stepper>
                        </>
                    ) : (
                        <Stepper alternativeLabel activeStep={activeStep} connector={<ColorlibConnector />}>
                            {steps.map((label, index) => (
                                <Step key={label}>
                                    <StepLabel StepIconComponent={(props) => (
                                        <ColorlibStepIcon
                                            {...props}
                                            theme={theme}
                                            icon={index + 1}
                                            onClick={() => handleStep(index)}
                                            error={touchedSteps[index] && stepsWithErrors[index]}
                                        />
                                    )}>
                                        {label}
                                    </StepLabel>
                                </Step>
                            ))}
                        </Stepper>
                    )}

                    {activeStep === 0 && (
                        <Box
                            display="grid"
                            gap="30px"
                            gridTemplateColumns="repeat(3, minmax(0, 1fr))"
                            sx={{
                                "& > div": { gridColumn: isNonMobile ? undefined : "span 3" },
                            }}
                        >
                            <FormControl variant="filled" sx={{ mt: 1, minWidth: 120 }}>
                                <TextField
                                    fullWidth
                                    variant="filled"
                                    type="text"
                                    label="Quotation NO :"
                                    onBlur={handleBlur}
                                    onChange={handleChange}
                                    value={QuotationNo}
                                    name="QuotationNO"
                                    error={!!touched.QuotationNO && !!errors.QuotationNO}
                                    helperText={touched.QuotationNO && errors.QuotationNO}
                                    InputLabelProps={{
                                        style: {
                                            color: theme.palette.text.primary
                                        }
                                    }}
                                />
                            </FormControl>

                            <FormControl variant="filled" sx={{ mt: 1, minWidth: 120 }}>
                                <TextField
                                    fullWidth
                                    variant="filled"
                                    type="date"
                                    label="Date:"
                                    onBlur={handleBlur}
                                    onChange={handleChange}
                                    value={values.Date}
                                    name="Date"
                                    error={!!touched.Date && !!errors.Date}
                                    helperText={touched.Date && errors.Date}
                                    InputLabelProps={{
                                        shrink: true,
                                        style: {
                                            color: theme.palette.text.primary
                                        }
                                    }}
                                />
                            </FormControl>
                            <FormControl variant="filled" sx={{ mt: 1, minWidth: 120 }}>
                                <TextField
                                    fullWidth
                                    variant="filled"
                                    type="text"
                                    label="Customer Name:"
                                    onBlur={handleBlur}
                                    onChange={handleChange}
                                    value={values.customerName}
                                    name="customerName"
                                    error={!!touched.customerName && !!errors.customerName}
                                    helperText={touched.customerName && errors.customerName}
                                    InputLabelProps={{
                                        style: {
                                            color: theme.palette.text.primary
                                        }
                                    }}
                                />
                            </FormControl>
                            <FormControl variant="filled" sx={{ mt: 1, minWidth: 120 }}>
                                <TextField
                                    fullWidth
                                    variant="filled"
                                    type="text"
                                    label="Location:"
                                    onBlur={handleBlur}
                                    onChange={handleChange}
                                    value={values.location}
                                    name="location"
                                    error={!!touched.location && !!errors.location}
                                    helperText={touched.location && errors.location}
                                    InputLabelProps={{
                                        style: {
                                            color: theme.palette.text.primary
                                        }
                                    }}
                                />
                            </FormControl>
                            <FormControl variant="filled" sx={{ mt: 1, minWidth: 120 }}>
                                <TextField
                                    fullWidth
                                    variant="filled"
                                    type="text"
                                    label="System Size:"
                                    onBlur={handleBlur}
                                    onChange={handleChange}
                                    value={values.systemSize}
                                    name="systemSize"
                                    error={!!touched.systemSize && !!errors.systemSize}
                                    helperText={touched.systemSize && errors.systemSize}
                                    InputLabelProps={{
                                        style: {
                                            color: theme.palette.text.primary
                                        }
                                    }}
                                />
                            </FormControl>
                            <TextField
                                margin="dense"
                                id="TypesOfProject"
                                name="TypesOfProject"
                                label="Types Of Project :"
                                select
                                fullWidth
                                variant="filled"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.TypesOfProject}
                                error={touched.TypesOfProject && Boolean(errors.TypesOfProject)}
                                helperText={touched.TypesOfProject && errors.TypesOfProject}
                                InputLabelProps={{
                                    style: {
                                        color: theme.palette.text.primary
                                    }
                                }}
                                sx={{ width: '100%' }}
                            >
                                <MenuItem value="Residential Individual">Residential Individual</MenuItem>
                                <MenuItem value="Residential Comman Meter">Residential Comman Meter</MenuItem>
                                <MenuItem value="Commercial with Large BOM">Commercial with Large BOM</MenuItem>
                                <MenuItem value="Commercial with Small BOM">Commercial with Small BOM</MenuItem>
                                <MenuItem value="Individual">Loan Quotation</MenuItem>
                            </TextField>
                        </Box>
                    )}

                    {activeStep === 1 && (
                        <>
                            {BomId || values?.bomId ? (
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                    <span> Bill of Materials </span>
                                    <RemoveRedEyeIcon
                                        sx={{ cursor: 'pointer' }}
                                        onClick={() => handleViewBom(BomId ? BomId : values?.bomId)}
                                    />
                                </Box>
                            ) : ('')}
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, color: theme.palette.text.primary, fontWeight: 'bold', textAlign: 'center', padding: '10px', fontSize: '14px' }}>No.</TableCell>
                                        <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, color: theme.palette.text.primary, fontWeight: 'bold', textAlign: 'center', padding: '10px', fontSize: '14px' }}>Product / Item</TableCell>
                                        <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, color: theme.palette.text.primary, fontWeight: 'bold', textAlign: 'center', padding: '10px', fontSize: '14px' }}>Make</TableCell>
                                        <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, color: theme.palette.text.primary, fontWeight: 'bold', textAlign: 'center', padding: '10px', fontSize: '14px' }}>Technical Specification</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {salesDetails.map((detail, index) => (
                                        <TableRow key={index}>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, color: theme.palette.text.primary, fontWeight: 'bold', textAlign: 'center', padding: '10px', fontSize: '14px' }}>{index + 1}.</TableCell>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, color: theme.palette.text.primary, fontWeight: 'bold', textAlign: 'center', padding: '10px', fontSize: '14px' }}>
                                                <TextField
                                                    fullWidth
                                                    variant="filled"
                                                    label="Product Name"
                                                    value={detail.salesproduct}
                                                    onChange={(e) => {
                                                        const newValue = e.target.value;
                                                        setFieldValue(`SalesDetails[${index}].salesproduct`, newValue);
                                                        setSalesDetails(prev => {
                                                            const updatedDetails = [...prev];
                                                            updatedDetails[index].salesproduct = newValue;
                                                            return updatedDetails;
                                                        });
                                                    }}
                                                />
                                            </TableCell>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, color: theme.palette.text.primary, fontWeight: 'bold', textAlign: 'center', padding: '10px', fontSize: '14px' }}>
                                                <TextField
                                                    fullWidth
                                                    variant="filled"
                                                    label="Make"
                                                    value={detail.salesmake}
                                                    onChange={(e) => {
                                                        const newValue = e.target.value;
                                                        setFieldValue(`SalesDetails[${index}].salesmake`, newValue);
                                                        setSalesDetails(prev => {
                                                            const updatedDetails = [...prev];
                                                            updatedDetails[index].salesmake = newValue;
                                                            return updatedDetails;
                                                        });
                                                    }}
                                                />
                                            </TableCell>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, color: theme.palette.text.primary, fontWeight: 'bold', textAlign: 'center', padding: '10px', fontSize: '14px' }}>
                                                <TextField
                                                    fullWidth
                                                    variant="filled"
                                                    label="Specification"
                                                    value={detail.salesspecifiaction}
                                                    onChange={(e) => {
                                                        const newValue = e.target.value;
                                                        setFieldValue(`SalesDetails[${index}].salesspecifiaction`, newValue);
                                                        setSalesDetails(prev => {
                                                            const updatedDetails = [...prev];
                                                            updatedDetails[index].salesspecifiaction = newValue;
                                                            return updatedDetails;
                                                        });
                                                    }}
                                                />
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </>
                    )}

                    {activeStep === 2 && (
                        <Box>
                            {(values.TypesOfProject === 'Residential Individual' || values.TypesOfProject === 'Residential Comman Meter') && (
                                <Table>
                                    <TableHead>
                                        <TableRow
                                        >
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, color: theme.palette.text.primary, fontWeight: 'bold', textAlign: 'center', padding: '10px', fontSize: '14px' }}>No.</TableCell>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, color: theme.palette.text.primary, fontWeight: 'bold', textAlign: 'center', padding: '10px', fontSize: '14px' }}>Product / Item</TableCell>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, color: theme.palette.text.primary, fontWeight: 'bold', textAlign: 'center', padding: '10px', fontSize: '14px' }}>Amount</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        <TableRow>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, textAlign: 'center', padding: '20px', color: theme.palette.text.primary, fontSize: '14px' }}>1.</TableCell>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, padding: '20px', color: theme.palette.text.primary, fontSize: '14px' }}>
                                                Supply, Installation, Testing & Commissioning of  {values.systemSize && (
                                                    <span style={{ color: '#00A651' }}>{values.systemSize} kWp</span>
                                                )} Grid Tied Solar Power Plant with Solar Panels, Solar Inverter, Module Mounting Structure & BOS.
                                            </TableCell>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, textAlign: 'center', padding: '20px', color: theme.palette.text.primary, fontSize: '14px' }}>
                                                <FormControl variant="filled" sx={{ mt: 1, minWidth: 120 }}>
                                                    <TextField
                                                        fullWidth
                                                        variant="filled"
                                                        type="text"
                                                        label="Amount :"
                                                        onBlur={handleBlur}
                                                        onChange={(e) => {
                                                            handleChange(e);
                                                            handleAmountChangeFS(e, 'Amount1');
                                                        }}
                                                        value={values.Amount1 || ''}
                                                        name="Amount1"
                                                        error={!!touched.Amount1 && !!errors.Amount1}
                                                        helperText={touched.Amount1 && errors.Amount1}
                                                        InputLabelProps={{
                                                            style: { color: theme.palette.text.primary }
                                                        }}
                                                    />

                                                </FormControl>
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, textAlign: 'center', padding: '20px', color: theme.palette.text.primary, fontSize: '14px' }}>2.</TableCell>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, padding: '20px', color: theme.palette.text.primary, fontSize: '14px' }}>
                                                Net Meter, Stamp and MCB Charge
                                            </TableCell>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, textAlign: 'center', padding: '20px', color: theme.palette.text.primary, fontSize: '14px' }}>
                                                <FormControl variant="filled" sx={{ mt: 1, minWidth: 120 }}>
                                                    <TextField
                                                        fullWidth
                                                        variant="filled"
                                                        type="text"
                                                        label="Amount :"
                                                        onBlur={handleBlur}
                                                        onChange={(e) => { handleChange(e.target.value); handleAmountChangeFS(e, 'Amount2') }}
                                                        value={values.Amount2 || ''}
                                                        name="Amount2"
                                                        error={!!touched.Amount2 && !!errors.Amount2}
                                                        helperText={touched.Amount2 && errors.Amount2}
                                                        InputLabelProps={{
                                                            style: {
                                                                color: theme.palette.text.primary
                                                            }
                                                        }}
                                                    />
                                                </FormControl>
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, textAlign: 'center', padding: '20px', color: theme.palette.text.primary, fontSize: '14px' }}>3.</TableCell>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, padding: '20px', color: theme.palette.text.primary, fontSize: '14px' }}>
                                                Super Structure and Extra Cable Charge
                                            </TableCell>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, textAlign: 'center', padding: '20px', color: theme.palette.text.primary, fontSize: '14px' }}>
                                                <FormControl variant="filled" sx={{ mt: 1, minWidth: 120 }}>
                                                    <TextField
                                                        fullWidth
                                                        variant="filled"
                                                        type="text"
                                                        label="Amount :"
                                                        onBlur={handleBlur}
                                                        onChange={(e) => { handleChange(e.target.value); handleAmountChangeFS(e, 'Amount3') }}
                                                        value={values.Amount3 || ''}
                                                        name="Amount3"
                                                        error={!!touched.Amount3 && !!errors.Amount3}
                                                        helperText={touched.Amount3 && errors.Amount3}
                                                        InputLabelProps={{
                                                            style: {
                                                                color: theme.palette.text.primary
                                                            }
                                                        }}
                                                    />
                                                </FormControl>
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, textAlign: 'center', padding: '20px', color: theme.palette.text.primary, fontSize: '14px' }}>4.</TableCell>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, padding: '20px', color: theme.palette.text.primary, fontSize: '14px' }}>
                                                Total Amount
                                            </TableCell>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, textAlign: 'center', padding: '20px', color: theme.palette.text.primary, fontSize: '14px' }}>
                                                <FormControl variant="filled" sx={{ mt: 1, minWidth: 120 }}>
                                                    <TextField
                                                        fullWidth
                                                        variant="filled"
                                                        type="text"
                                                        label="Amount :"
                                                        onBlur={handleBlur}
                                                        value={values.Amount4 || ''}
                                                        name="Amount4"
                                                        error={!!touched.Amount4 && !!errors.Amount4}
                                                        helperText={touched.Amount4 && errors.Amount4}
                                                        InputLabelProps={{
                                                            style: {
                                                                color: theme.palette.text.primary
                                                            }
                                                        }}
                                                        InputProps={{
                                                            readOnly: true,
                                                        }}
                                                    />
                                                </FormControl>
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, textAlign: 'center', padding: '20px', color: theme.palette.text.primary, fontSize: '14px' }}>5.</TableCell>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, padding: '20px', color: theme.palette.text.primary, fontSize: '14px' }}>
                                                Government Subsidy Benefit
                                            </TableCell>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, textAlign: 'center', padding: '20px', color: theme.palette.text.primary, fontSize: '14px' }}>
                                                <FormControl variant="filled" sx={{ mt: 1, minWidth: 120 }}>
                                                    <TextField
                                                        fullWidth
                                                        variant="filled"
                                                        type="text"
                                                        label="Amount :"
                                                        onBlur={handleBlur}
                                                        onChange={(e) => { handleChange(e.target.value); handleAmountChangeFS(e, 'Amount5') }}
                                                        value={values.Amount5 || ''}
                                                        name="Amount5"
                                                        error={!!touched.Amount5 && !!errors.Amount5}
                                                        helperText={touched.Amount5 && errors.Amount5}
                                                        InputLabelProps={{
                                                            style: {
                                                                color: theme.palette.text.primary
                                                            }
                                                        }}
                                                    />
                                                </FormControl>
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, textAlign: 'center', padding: '20px', color: theme.palette.text.primary, fontSize: '14px' }}>6.</TableCell>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, padding: '20px', color: theme.palette.text.primary, fontSize: '14px' }}>
                                                Price After Subsidy
                                            </TableCell>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, textAlign: 'center', padding: '20px', color: theme.palette.text.primary, fontSize: '14px' }}>
                                                <FormControl variant="filled" sx={{ mt: 1, minWidth: 120 }}>
                                                    <TextField
                                                        fullWidth
                                                        variant="filled"
                                                        type="text"
                                                        label="Amount :"
                                                        onBlur={handleBlur}
                                                        value={values.Amount6 || ''}
                                                        name="Amount6"
                                                        error={!!touched.Amount6 && !!errors.Amount6}
                                                        helperText={touched.Amount6 && errors.Amount6}
                                                        InputLabelProps={{
                                                            style: {
                                                                color: theme.palette.text.primary
                                                            }
                                                        }}
                                                        InputProps={{
                                                            readOnly: true,
                                                        }}
                                                    />
                                                </FormControl>
                                            </TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            )}
                            {(values.TypesOfProject === 'Commercial with Large BOM') && (
                                <Table>
                                    <TableHead>
                                        <TableRow
                                        >
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, color: theme.palette.text.primary, fontWeight: 'bold', textAlign: 'center', padding: '10px', fontSize: '14px' }}>No.</TableCell>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, color: theme.palette.text.primary, fontWeight: 'bold', textAlign: 'center', padding: '10px', fontSize: '14px' }}>Product / Item</TableCell>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, color: theme.palette.text.primary, fontWeight: 'bold', textAlign: 'center', padding: '10px', fontSize: '14px' }}>Amount</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        <TableRow>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, textAlign: 'center', padding: '20px', color: theme.palette.text.primary, fontSize: '14px' }}>1.</TableCell>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, padding: '20px', color: theme.palette.text.primary, fontSize: '14px' }}>
                                                Supply, Installation, Testing & Commissioning of <span style={{ color: '#00A651' }}>{values.systemSize} kWp</span> Grid Tied Solar Power Plant with Solar Panels, Solar Inverter, Module Mounting Structure & BOS.
                                            </TableCell>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, textAlign: 'center', padding: '20px', color: theme.palette.text.primary, fontSize: '14px' }}>
                                                <FormControl variant="filled" sx={{ mt: 1, minWidth: 120 }}>
                                                    <TextField
                                                        fullWidth
                                                        variant="filled"
                                                        type="text"
                                                        onBlur={handleBlur}
                                                        onChange={(e) => handleAmountChange(e, 'Amount1')}
                                                        value={values.Amount1 || ''}
                                                        name="Amount1"
                                                        error={!!touched.Amount1 && !!errors.Amount1}
                                                        helperText={touched.Amount1 && errors.Amount1}
                                                        InputLabelProps={{
                                                            style: {
                                                                color: theme.palette.text.primary
                                                            }
                                                        }}
                                                    />
                                                </FormControl>
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, textAlign: 'center', padding: '20px', color: theme.palette.text.primary, fontSize: '14px' }}>2.</TableCell>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, padding: '20px', color: theme.palette.text.primary, fontSize: '14px' }}>
                                                {new Date(values?.Date) <= new Date("2025-09-21") ? 'GST (13.8%)' : 'GST (8.9%)'}
                                            </TableCell>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, textAlign: 'center', padding: '20px', color: theme.palette.text.primary, fontSize: '14px' }}>
                                                <FormControl variant="filled" sx={{ mt: 1, minWidth: 120 }}>
                                                    <TextField
                                                        fullWidth
                                                        variant="filled"
                                                        type="text"
                                                        onBlur={handleBlur}
                                                        value={values.Amount2}
                                                        name="Amount2"
                                                        error={!!touched.Amount2 && !!errors.Amount2}
                                                        helperText={touched.Amount2 && errors.Amount2}
                                                        InputProps={{
                                                            readOnly: true,
                                                        }}
                                                        InputLabelProps={{
                                                            style: {
                                                                color: theme.palette.text.primary
                                                            }
                                                        }}
                                                    />
                                                </FormControl>
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, textAlign: 'center', padding: '20px', color: theme.palette.text.primary, fontSize: '14px' }}>3.</TableCell>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, padding: '20px', color: theme.palette.text.primary, fontSize: '14px' }}>
                                                Total
                                            </TableCell>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, textAlign: 'center', padding: '20px', color: theme.palette.text.primary, fontSize: '14px' }}>
                                                <FormControl variant="filled" sx={{ mt: 1, minWidth: 120 }}>
                                                    <TextField
                                                        fullWidth
                                                        variant="filled"
                                                        type="text"
                                                        onBlur={handleBlur}
                                                        value={values.Amount3}
                                                        name="Amount3"
                                                        error={!!touched.Amount3 && !!errors.Amount3}
                                                        helperText={touched.Amount3 && errors.Amount3}
                                                        InputProps={{
                                                            readOnly: true,
                                                        }}
                                                        InputLabelProps={{
                                                            style: {
                                                                color: theme.palette.text.primary
                                                            }
                                                        }}
                                                    />
                                                </FormControl>
                                            </TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            )}
                            {(values.TypesOfProject === 'Commercial with Small BOM') && (
                                <Table>
                                    <TableHead>
                                        <TableRow
                                        >
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, color: theme.palette.text.primary, fontWeight: 'bold', textAlign: 'center', padding: '10px', fontSize: '14px' }}>No.</TableCell>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, color: theme.palette.text.primary, fontWeight: 'bold', textAlign: 'center', padding: '10px', fontSize: '14px' }}>Product / Item</TableCell>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, color: theme.palette.text.primary, fontWeight: 'bold', textAlign: 'center', padding: '10px', fontSize: '14px' }}>Amount</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        <TableRow>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, textAlign: 'center', padding: '20px', color: theme.palette.text.primary, fontSize: '14px' }}>1.</TableCell>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, padding: '20px', color: theme.palette.text.primary, fontSize: '14px' }}>
                                                Supply, Installation, Testing & Commissioning of <span style={{ color: '#00A651' }}>{values.systemSize} kWp</span> Grid Tied Solar Power Plant with Solar Panels, Solar Inverter, Module Mounting Structure & BOS.
                                            </TableCell>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, textAlign: 'center', padding: '20px', color: theme.palette.text.primary, fontSize: '14px' }}>
                                                <FormControl variant="filled" sx={{ mt: 1, minWidth: 120 }}>
                                                    <TextField
                                                        fullWidth
                                                        variant="filled"
                                                        type="text"
                                                        onBlur={handleBlur}
                                                        onChange={(e) => handleAmountChange(e, 'Amount1')}
                                                        value={values.Amount1 || ''}
                                                        name="Amount1"
                                                        error={!!touched.Amount1 && !!errors.Amount1}
                                                        helperText={touched.Amount1 && errors.Amount1}
                                                        InputLabelProps={{
                                                            style: {
                                                                color: theme.palette.text.primary
                                                            }
                                                        }}
                                                    />
                                                </FormControl>
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, textAlign: 'center', padding: '20px', color: theme.palette.text.primary, fontSize: '14px' }}>2.</TableCell>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, padding: '20px', color: theme.palette.text.primary, fontSize: '14px' }}>
                                                {new Date(values.Date) <= new Date("2025-09-21") ? 'GST (13.8%)' : 'GST (8.9%)'}
                                            </TableCell>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, textAlign: 'center', padding: '20px', color: theme.palette.text.primary, fontSize: '14px' }}>
                                                <FormControl variant="filled" sx={{ mt: 1, minWidth: 120 }}>
                                                    <TextField
                                                        fullWidth
                                                        variant="filled"
                                                        type="text"
                                                        onBlur={handleBlur}
                                                        value={values.Amount2}
                                                        name="Amount2"
                                                        error={!!touched.Amount2 && !!errors.Amount2}
                                                        helperText={touched.Amount2 && errors.Amount2}
                                                        InputLabelProps={{
                                                            style: {
                                                                color: theme.palette.text.primary
                                                            }
                                                        }}
                                                        InputProps={{
                                                            readOnly: true,
                                                        }}
                                                    />
                                                </FormControl>
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, textAlign: 'center', padding: '20px', color: theme.palette.text.primary, fontSize: '14px' }}>3.</TableCell>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, padding: '20px', color: theme.palette.text.primary, fontSize: '14px' }}>
                                                Total
                                            </TableCell>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, textAlign: 'center', padding: '20px', color: theme.palette.text.primary, fontSize: '14px' }}>
                                                <FormControl variant="filled" sx={{ mt: 1, minWidth: 120 }}>
                                                    <TextField
                                                        fullWidth
                                                        variant="filled"
                                                        type="text"
                                                        onBlur={handleBlur}
                                                        value={values.Amount3}
                                                        name="Amount3"
                                                        error={!!touched.Amount3 && !!errors.Amount3}
                                                        helperText={touched.Amount3 && errors.Amount3}
                                                        InputLabelProps={{
                                                            style: {
                                                                color: theme.palette.text.primary
                                                            }
                                                        }}
                                                        InputProps={{
                                                            readOnly: true,
                                                        }}
                                                    />
                                                </FormControl>
                                            </TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            )}
                            {(values.TypesOfProject === 'Individual') && (
                                <Table>
                                    <TableHead>
                                        <TableRow
                                        >
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, color: theme.palette.text.primary, fontWeight: 'bold', textAlign: 'center', padding: '10px', fontSize: '14px' }}>No.</TableCell>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, color: theme.palette.text.primary, fontWeight: 'bold', textAlign: 'center', padding: '10px', fontSize: '14px' }}>Product / Item</TableCell>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, color: theme.palette.text.primary, fontWeight: 'bold', textAlign: 'center', padding: '10px', fontSize: '14px' }}>Amount</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        <TableRow>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, textAlign: 'center', padding: '20px', color: theme.palette.text.primary, fontSize: '14px' }}>1.</TableCell>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, padding: '20px', color: theme.palette.text.primary, fontSize: '14px' }}>
                                                Design,supply,erection and commissioning of roof top grid tied solar PV power generation plant with standard lengths of wires. The solar power plant will consist of required no. of SPV panels, inverter and with all the electrical items suitable to the designed installed capacity.
                                            </TableCell>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, textAlign: 'center', padding: '20px', color: theme.palette.text.primary, fontSize: '14px' }}>
                                                <FormControl variant="filled" sx={{ mt: 1, minWidth: 120 }}>
                                                    <TextField
                                                        fullWidth
                                                        variant="filled"
                                                        type="text"
                                                        onBlur={handleBlur}
                                                        onChange={(e) => handleAmountChange(e, 'Amount1')}
                                                        value={values.Amount1 || ''}
                                                        name="Amount1"
                                                        error={!!touched.Amount1 && !!errors.Amount1}
                                                        helperText={touched.Amount1 && errors.Amount1}
                                                        InputLabelProps={{
                                                            style: {
                                                                color: theme.palette.text.primary
                                                            }
                                                        }}
                                                    />
                                                </FormControl>
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, textAlign: 'center', padding: '20px', color: theme.palette.text.primary, fontSize: '14px' }}>2.</TableCell>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, padding: '20px', color: theme.palette.text.primary, fontSize: '14px' }}>
                                                {'Rate/KW'}
                                            </TableCell>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, textAlign: 'center', padding: '20px', color: theme.palette.text.primary, fontSize: '14px' }}>
                                                {(values.Amount1 / values.systemSize).toFixed(2)}
                                            </TableCell>
                                        </TableRow>
                                        
                                    </TableBody>
                                </Table>
                            )}

                        </Box>
                    )}

                    {activeStep === 3 && (
                        <Box sx={{ mt: 2, mb: 2 }}>
                            <Typography variant="h4" fontWeight={600} gutterBottom>Terms and Conditions</Typography>
                            <Box>
                                {terms?.filter(t => t.TermsType === "Sales")?.map((t) => (
                                    <Box key={t._id} sx={{ p: 1, borderRadius: 1 }}>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={acceptedTerms[t._id] || false}
                                                    onChange={() => handleTermChange(t._id)}
                                                    name={`term-${t._id}`}
                                                    sx={{
                                                        color: theme.palette.mode === 'dark' ? '#fff' : '#000',
                                                        '&.Mui-checked': {
                                                            color: theme.palette.mode === 'dark' ? '#fff' : '#000',
                                                        },
                                                    }}
                                                />
                                            }
                                            label={
                                                <div style={{ display: 'flex' }}>
                                                    <Typography sx={{ fontWeight: 'bold', mb: 0.5, mr: 2 }}>{t.name}</Typography>
                                                    <Typography sx={{ mb: 0.5 }}>{t.description}</Typography>
                                                </div>

                                            }
                                        />
                                    </Box>
                                ))}
                            </Box>
                        </Box>
                    )}

                    <Dialog
                        open={open}
                        onClose={handleClose}
                        aria-labelledby="bom-dialog-title"
                        aria-describedby="bom-dialog-description"
                        maxWidth="md"
                        fullWidth
                    >
                        <DialogTitle id="bom-dialog-title" sx={{ textAlign: 'center', fontWeight: 'bold', fontSize: '16px' }}>
                            Bill of Materials Details
                        </DialogTitle>
                        <DialogContent>
                            <DialogContentText id="bom-dialog-description">
                                <div style={{ display: 'flex', color: theme.palette.text.primary }}>
                                    <ul style={{ listStyle: 'none', padding: 0 }}>
                                        <li>Name</li>
                                        <li>System Size </li>
                                        <li>Date </li>
                                        <li>Types Of Project </li>
                                    </ul>
                                    <ul style={{ listStyle: 'none' }}>
                                        <li>: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{bomData?.BOMName}</li>
                                        <li>: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{bomData?.systemSize}</li>
                                        <li>: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{formatDate(bomData?.Date)}</li>
                                        <li>: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{bomData?.TypesOfProject}</li>
                                    </ul>
                                </div>

                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>Category</TableCell>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>Sub Category</TableCell>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>Product</TableCell>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>Description</TableCell>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>Quantity</TableCell>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>Price</TableCell>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>Total</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {bomData?.BomDetails?.map((bom, index) => (
                                            <TableRow key={index}>
                                                <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>
                                                    {categories?.find(category => category._id === bom?.bomcategory)?.categoryName || bom?.bomcategory}
                                                </TableCell>
                                                <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>
                                                    {subcategories?.find(subcategory => subcategory._id === bom?.bomsubcategory)?.subCategoryName || bom?.bomsubcategory}
                                                </TableCell>
                                                <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>
                                                    {productData?.find(product => product._id === bom?.bomproduct)?.productName || bom?.bomproduct}
                                                </TableCell>
                                                <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>
                                                    {bom?.bomdescription}
                                                </TableCell>
                                                <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>
                                                    {bom?.bomqty}
                                                </TableCell>
                                                <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>
                                                    {bom?.bomlastprice}
                                                </TableCell>
                                                <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>
                                                    {bom?.bomamount}
                                                </TableCell>
                                            </TableRow>
                                        ))
                                        }
                                    </TableBody>
                                </Table>

                                <Table sx={{ mt: 2 }}>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}></TableCell>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>Remarks</TableCell>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>System Size</TableCell>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>Unit Price</TableCell>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>Amount</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        <TableRow>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>Dealer Commission in KW</TableCell>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>{bomData?.Remarks1}</TableCell>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>{bomData?.SystemSize1}</TableCell>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>{bomData?.unitprice1}</TableCell>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>{bomData?.Amount1}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>Interest</TableCell>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>{bomData?.Remarks2}</TableCell>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>{bomData?.SystemSize2}</TableCell>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>{bomData?.unitprice2}</TableCell>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>{bomData?.Amount2}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>Service & Maintenance</TableCell>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>{bomData?.Remarks3}</TableCell>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>{bomData?.SystemSize3}</TableCell>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>{bomData?.unitprice3}</TableCell>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>{bomData?.Amount3}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>Profit in KW</TableCell>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>{bomData?.Remarks4}</TableCell>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>{bomData?.systemSize}</TableCell>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>{bomData?.unitprice4}</TableCell>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>{bomData?.Amount4}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>Net Meter, Stamp and MCB Charge</TableCell>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>{bomData?.Remarks5}</TableCell>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>{bomData?.SystemSize5}</TableCell>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>{bomData?.unitprice5}</TableCell>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>{bomData?.Amount5}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>Super Structure and Extra Cabel Charge</TableCell>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>{bomData?.Remarks6}</TableCell>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>{bomData?.SystemSize6}</TableCell>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>{bomData?.unitprice6}</TableCell>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>{bomData?.Amount6}</TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>

                                <Table sx={{ mt: 2 }}>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>Total</TableCell>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>GST</TableCell>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>TotalAmount</TableCell>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>Subcidy</TableCell>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>Price After Subcidy	</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        <TableRow>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>{bomData?.Total}</TableCell>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>{bomData?.GST}</TableCell>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>{bomData?.TotalAmount}</TableCell>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>{bomData?.subcidy}</TableCell>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>{bomData?.PriceAfterSubcidy}</TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>

                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={handleClose} sx={{ color: theme.palette.text.primary }}>
                                Close
                            </Button>
                        </DialogActions>
                    </Dialog>

                    <FormControl>
                        <Stack direction="row" spacing={2} sx={{ m: 1, minWidth: 120 }}>
                            <Button
                                variant="contained"
                                disabled={activeStep === 0}
                                onClick={handleBack}
                            >
                                Back

                            </Button>
                            {activeStep < 3 && (
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={handleNext}
                                >
                                    Next
                                </Button>
                            )}
                            <Button
                                variant="contained"
                                color="primary"
                                type="button"
                                onClick={() => handleSubmit(values)}
                            >
                                {id ? 'Update' : 'Save'}
                            </Button>
                        </Stack>
                    </FormControl>
                </Stack >
            </form >
        </Box >
    )
}

export default AddSales
